import axios from "axios";
import { Config } from "./config";
import { useAuthStore } from "../store/useAuthStore";

const mock_api = axios.create({
  baseURL: "https://a1e4a6a8-42f9-4f0c-b60f-2e2f82aca35d.mock.pstmn.io/api/v1",
});

const api = axios.create({
  baseURL: Config.apiGateWay.URL,
});

// =======================
// INTERCEPTOR (set up immediately, not in useEffect)
// =======================
api.interceptors.request.use(
  (config) => {
    const token = useAuthStore.getState().token;

    // Always attach token if available
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    return config;
  },
  (error) => Promise.reject(error)
);

export { mock_api, api };
